export const LOCATION_ERROR = {
  NOT_SUPPORTED: "LOCATION_NOT_SUPPORTED",
  PERMISSION_DENIED: "LOCATION_PERMISSION_DENIED",
  POSITION_UNAVAILABLE: "LOCATION_UNAVAILABLE",
  TIMEOUT: "LOCATION_TIMEOUT",
  INSECURE_CONTEXT: "LOCATION_INSECURE_CONTEXT",
};

export function getBrowserLocation() {
  return new Promise((resolve) => {
    if (typeof window !== "undefined" && !window.isSecureContext) {
      resolve({
        success: false,
        error: LOCATION_ERROR.INSECURE_CONTEXT,
        latitude: null,
        longitude: null,
      });
      return;
    }

    if (!navigator.geolocation) {
      resolve({
        success: false,
        error: LOCATION_ERROR.NOT_SUPPORTED,
        latitude: null,
        longitude: null,
      });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          success: true,
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      (error) => {
        let errorCode = LOCATION_ERROR.POSITION_UNAVAILABLE;
        if (error.code === error.PERMISSION_DENIED) {
          errorCode = LOCATION_ERROR.PERMISSION_DENIED;
        } else if (error.code === error.TIMEOUT) {
          errorCode = LOCATION_ERROR.TIMEOUT;
        }
        resolve({
          success: false,
          error: errorCode,
          latitude: null,
          longitude: null,
        });
      },
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
    );
  });
}
